import type { RouteLocationRaw } from 'vue-router'
import { PERMISSION } from '@/models/role'
import { useAuthStore } from '@/stores/auth'

export function resolveNotificationRoute (notification: Notification): RouteLocationRaw | null {
  const { class: className, model_id: id } = notification.data

  if (!className) return null

  const auth = useAuthStore()
  const isAdmin = auth.can('mengakses halaman admin') || auth.user?.role === 'superadmin'

  if (isAdmin) {
    if (className.includes('Sale')) {
      return id ? { name: 'sale detail', params: { id } } : { name: 'sale list' }
    }

    if (className.includes('Purchase')) {
      return id ? { name: 'purchase detail', params: { id } } : { name: 'purchase list' }
    }

    if (className.includes('LoanPayment')) {
      return id ? { name: 'loan payment detail', params: { id } } : { name: 'loan payment list' }
    }

    if (className.includes('Loan')) {
      return id ? { name: 'loan detail', params: { id } } : { name: 'loan list' }
    }

    if (className.includes('Saving')) {
      return { name: 'saving list' }
    }

    if (className.includes('ProductDamage')) {
      return id ? { name: 'product damage detail', params: { id } } : { name: 'product damage list' }
    }

    if (className.includes('StockOpname')) {
      return id ? { name: 'stockopname detail', params: { id } } : { name: 'product stockopname list' }
    }
  } else {
    // Non-admin (Member / Mobile View)
    if (className.includes('Sale')) {
      return { name: 'profile my purchase list' }
    }
    if (className.includes('Loan') || className.includes('LoanPayment')) {
      return { name: 'profile my loan list' }
    }
    if (className.includes('Saving')) {
      return { name: 'profile my saving list' }
    }
  }

  return null
}

export function canShowNotification (notification: Notification, auth: { can: (p: string) => boolean }): boolean {
  const className = notification.data.class

  if (!className) return true

  // If it's a User notification, always show
  if (className.includes('Notifications\\User\\')) return true

  // Mapping Admin Notifications to Permissions
  if (className.includes('Notifications\\Admin\\')) {
    if (className.includes('SaleCreated')) return auth.can(PERMISSION.NOTIFICATION_SALE_CREATED)
    if (className.includes('SaleProcessed')) return auth.can(PERMISSION.NOTIFICATION_SALE_PROCESSED)
    if (className.includes('PurchaseBuyPaymentCreated')) return auth.can(PERMISSION.NOTIFICATION_PURCHASE_BUY_PAYMENT)
    if (className.includes('PurchaseReturPaymentCreated')) return auth.can(PERMISSION.NOTIFICATION_PURCHASE_RETUR_PAYMENT)
    if (className.includes('LoanCreated')) return auth.can(PERMISSION.NOTIFICATION_LOAN_CREATED)
    if (className.includes('LoanApproved')) return auth.can(PERMISSION.NOTIFICATION_LOAN_APPROVED)
    if (className.includes('LoanRejected')) return auth.can(PERMISSION.NOTIFICATION_LOAN_REJECTED)
    if (className.includes('SavingCreated')) return auth.can(PERMISSION.NOTIFICATION_SAVING_CREATED)
  }

  return true
}
